import { CancellablePromise } from '@lifaon/observables';
export function ExecLastRouteOfRoutesPath(routesPath, options) {
    var last;
    if ((routesPath.length > 0)
        && ((last = routesPath[routesPath.length - 1]).exec !== null)) {
        return last.exec(options);
    }
    else {
        return CancellablePromise.reject(new Error("The last route of routePath doesn't have an exec function"), options);
    }
}
//# sourceMappingURL=exec-last-route-of-routes-path.js.map